import { render, staticRenderFns } from "./NewPageGen.vue?vue&type=template&id=60423724&"
import script from "./NewPageGen.vue?vue&type=script&lang=js&"
export * from "./NewPageGen.vue?vue&type=script&lang=js&"
import style0 from "./NewPageGen.vue?vue&type=style&index=0&id=60423724&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports